import React from "react";
import {Box} from "@mui/material";
import QRCode from "react-qr-code";

import {useVarAuth} from "../../../graphql/graphql/auth/defaults";

const QRLink = () => {
  const {user} = useVarAuth();

  const refLink = `https://buythedip.com/?referrer=${user.referralCode}`;

  return (
    <div className="linkSect ">
      <Box className="qrcodeImg ">
        <QRCode width={100} value={refLink} />
      </Box>
    </div>
  );
};

export default QRLink;
